import React from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Segments/ScrolToTop';



const App = () => {
  
  return (
    
    <div className="App">
      <Components />  
      <ScrolToTop/>
    </div>
  );
}

export default App;
